import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgScrollbarModule } from "ngx-scrollbar";
import { AppRouting } from "./app-routing";

import { CommonModule, registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { provideNgxMask } from "ngx-mask";
import { environment } from "../environments/environment";
import { AppComponent } from "./app.component";
import { AlertDialogService } from "./components/_alert-dialog/alert-dialog.service";
import { ModalModule } from "./components/_modal";
import { WindowManagerModule } from "./components/_window-manager/window-manager.module";
import { PwaInstallComponent } from "./components/pwa-install/pwa-install.component";
import { BottomSheetComponent } from "./core/bottom-sheet/bottom-sheet.component";
import { SpinnerModule } from "./core/spinner/spinner.module";
import { SvgProfilModule } from "./core/svg/svg-profil/svg-profil.module";
import { ForgotDialog } from "./login/forgot-dialog/forgot-dialog";
import { LoginComponent } from "./login/login.component";
import { MaterialModule } from "./material-module";
import { NotfoundComponent } from "./notfound/notfound.component";
import { PagesComponent } from "./pages/pages.component";
import { ToolsService } from "./services/tools.service";
import { ToastrModule } from "./components/_toastr/toastr.module";
import { LoadingDialogModule } from "./components/_loading-dialog/loading-dialog.module";
import { ProgressDialogModule } from "./components/_progress-dialog/progress-dialog.module";
import { provideLottieOptions } from "ngx-lottie";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";

registerLocaleData(localeFr, "fr");

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PagesComponent,
    NotfoundComponent,
    ForgotDialog,
  ],
  imports: [
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
      registrationStrategy: "registerWhenStable:3000",
    }),
    BrowserModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRouting,
    SpinnerModule,
    BrowserAnimationsModule,
    MaterialModule,
    ModalModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    NgxMatSelectSearchModule,
    SvgProfilModule,
    NgScrollbarModule,
    WindowManagerModule,
    PwaInstallComponent,
    ToastrModule,
    LoadingDialogModule,
    ProgressDialogModule,
  ],
  providers: [
    AlertDialogService,
    ToolsService,
    BottomSheetComponent,
    provideLottieOptions({
      player: () => import("lottie-web"),
    }),
    provideNgxMask(),
    provideCharts(withDefaultRegisterables()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
